import API from "../api";
import type { LoginClienteRequest } from "models/cliente";
import Endpoints from "services/api/endpoints";
import { cpfUnmask } from "../../utils/mask";
import {
  CartaoBloqueioRequest,
  CartaoReemissaoRequest,
  DesbloqueioCartaoType,
} from "models/cartao";

export const getTokenCliente = (login: LoginClienteRequest) => {
  return API.post(Endpoints.usuario.loginCliente, {
    ...login,
    cpf: cpfUnmask(login.cpf),
  });
};

export const bloqueioCartaoCliente = (cartao: CartaoBloqueioRequest) => {
  return API.put(Endpoints.autorizador.bloquearCartao, { ...cartao });
};

export const reemissaoCartaoCliente = (props: CartaoReemissaoRequest) => {
  return API.post(Endpoints.autorizador.reemissaoCartao, { ...props });
};

export const getTokenCartaoByNumero = (numeroCartao: string) => {
  return API.post(Endpoints.autorizador.getTokenNumeroCartao, { numeroCartao });
};

export const getSaldoClienteTokenCartao = (tokenCartao: string) => {
  return API.post(Endpoints.autorizador.getSaldoClienteByTokenCartao, {
    tokenCartao,
  });
};

export const getFaturaAtualCliente = (numeroCartao: string) => {
  return API.post(Endpoints.autorizador.getFaturaAtualCliente, {
    numeroCartao,
  });
};

export const postValidarCartao = (tokenCartao: string) => {
  return API.post(Endpoints.autorizador.validarCartao, { tokenCartao });
};

export const postExtratoCartao = async (props: any) => {
  return API.post(Endpoints.autorizador.postExtratoCartao, {
    numeroCartao: props.dadosLogin.numeroCartao,
    dias: props.limite,
  });
};

export const getListaFaturas = async (
  cpf: string,
  numeroCartao: string,
  tokenCartao: string
) => {
  return API.get(
    Endpoints.relatorio.getListaFaturas
      .replace("PARAM_CPF", cpf)
      .replace("PARAM_NRCARTAO", numeroCartao)
      .replace("PARAM_TOKEN", tokenCartao)
  );
};

export const putValidaPushSMS = async (props: DesbloqueioCartaoType) => {
  return API.put(Endpoints.notificacao.putValidaNotificacao, {
    tokenCartao: props.tokenCartao,
    numeroGerado: props.tokenSMSUmask,
  });
};

export const putActivateCC = async (props: DesbloqueioCartaoType) => {
  return API.put(Endpoints.autorizador.putActivateCC, {
    tokenCartao: props.tokenCartao,
    senha: props.criarSenha,
  });
};

export const postSendTokenSMS = async (props: DesbloqueioCartaoType) => {
  return API.post(Endpoints.notificacao.potEnviaPushSMS, {
    tokenCartao: props.tokenCartao,
  });
};

export const putDesbloquearCC = async (props: DesbloqueioCartaoType) => {
  return API.put(Endpoints.autorizador.putDesbloquearCC, {
    tokenCartao: props.tokenCartao,
    senha: props.criarSenha,
    optionWhatsApp: props.whatsApp,
    optionTermoUso: props.termos,
    origemAcao: props.origemAcao,
  });
};
